import { createSlice } from '@reduxjs/toolkit';

const userSlice = createSlice({
  name: 'user',
  initialState: {
    users: [],
    dataValid: false
  },
  reducers: {
    setUsers(state, action) {
      console.count("userSlice: setUsers");
      if (!action || !action.payload || !action.payload.users) {
        state.users = [];    
      } else {
        state.users = action.payload.users;
        state.dataValid = !!action.payload.dataValid;
      }
    },
    setUser(state, action) {
      if (!action || !action.payload || !!action.payload.user) return;
      state.users = state.users
        .filter((item) => item.id !== action.payload.user.id)
        .push(action.payload.user);
    },
    removeUser(state, action) {
      if (!action || !action.payload || !!action.payload.user) return;
      state.users = state.users.filter((item) => item.id !== action.payload.user.id);
    },
    patchSkillLevels(state, action) {

      if (!action || !action.payload || !action.payload.skillLevels) {
        state.dataValid = false;
        return;
      }

      state.dataValid = !!action.payload.dataValid;

      if (!state.users) return;

      action.payload.skillLevels.forEach(updatedUserLevels => {
        if (!updatedUserLevels) return;
        if (!updatedUserLevels.userId) return;
        if (!updatedUserLevels.skillLevels && !updatedUserLevels.removedSkills) return;

//        let userLevels = state.skillLevels.find(item => item.userId === updatedUserLevels.userId);
        let user = state.users.find(item => item.id === updatedUserLevels.userId);

        if(!user) return;

        if(updatedUserLevels.skillLevels){
          if(!user.skills){
            user.skills = updatedUserLevels.skillLevels;
          } else {
            updatedUserLevels.skillLevels.forEach(updatedLevel => {
              let level = user.skills.find(item => item.id === updatedLevel.id);
              if (!level) {
                level = {
                  id: updatedLevel.id,
                  proficiency: updatedLevel.proficiency,
                }
                user.skills.push(level);
              } else {
                level.proficiency = updatedLevel.proficiency;
              }

            });
          }
        }

        if(updatedUserLevels.removedSkills){
          updatedUserLevels.removedSkills.forEach(removedSkill => {

            if(user.skills){
              //Remove skill from list
              let index = user.skills.findIndex(item => item.id === removedSkill.id);
              if(index => 0){
                user.skills.splice(index, 1);
              }
            }
          });
        }
      });
    },
    patchLanguageLevels(state, action) {
      if (!action || !action.payload || !action.payload.skillLevels) {
        state.dataValid = false;
        return;
      }

      state.dataValid = !!action.payload.dataValid;

      if (!state.users) return;

      action.payload.skillLevels.forEach(updatedUserLevels => {
        if (!updatedUserLevels) return;
        if (!updatedUserLevels.userId) return;
        if (!updatedUserLevels.skillLevels && !updatedUserLevels.removedSkills) return;

        let user = state.users.find(item => item.id === updatedUserLevels.userId);

        if(!user) return;

        if(updatedUserLevels.skillLevels){
          if (!user.languages) {
            user.languages = updatedUserLevels.skillLevels;
          } else {
            updatedUserLevels.skillLevels.forEach(updatedLevel => {
              let level = user.languages.find(item => item.id === updatedLevel.id);
              if (!level) {
                level = {
                  id: updatedLevel.id,
                  proficiency: updatedLevel.proficiency,
                }
                user.languages.push(level);
              } else {
                level.proficiency = updatedLevel.proficiency;
              }

            });
          }
        }

        if(updatedUserLevels.removedSkills){
          updatedUserLevels.removedSkills.forEach(removedSkill => {

            if(user.languages){
              //Remove skill from list
              let index = user.languages.findIndex(item => item.id === removedSkill.id);
              if(index => 0){
                user.languages.splice(index, 1);
              }
            }
          });
        }

      });

    },
    invalidateData(state, action) {
      state.dataValid = false;
    }
  },
});

export const userActions = userSlice.actions;

export default userSlice;